// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const Eraser = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'm21.094 7.538-3.882-3.882a2.25 2.25 0 0 0-3.181 0L2.906 14.781a2.25 2.25 0 0 0 0 3.182l2.818 2.818a.75.75 0 0 0 .533.219H20.25a.75.75 0 0 0 0-1.5h-7.94l8.784-8.78a2.25 2.25 0 0 0 0-3.182ZM10.189 19.5H6.567l-2.599-2.599a.75.75 0 0 1 0-1.06L9 10.81l4.94 4.939Zm9.844-9.844L15 14.69l-4.94-4.94 5.034-5.03a.75.75 0 0 1 1.061 0l3.88 3.879a.75.75 0 0 1 0 1.06Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'Eraser',
})
